export function getTranslation(lang: string): {
    aprAndTerm: string;
    loanAmount: string;
    monthlyPayment: string;
    months: string;
} {
    const translationStrings = {
        en: {
            aprAndTerm: 'APR and term',
            loanAmount: 'Loan amount',
            monthlyPayment: 'Monthly Payment',
            months: 'months',
        },
        es: {
            aprAndTerm: 'TAE y plazo',
            loanAmount: 'Monto del préstamo',
            monthlyPayment: 'Mensualidad',
            months: 'meses',
        }
    }
    return translationStrings[lang];
}
